'use strict'

module.exports = {
  full: address => {
    const lines = []
    lines.push(address.line1)
    if (address.line2) {
      lines.push(address.line2)
    }
    lines.push(`${address.city}, ${address.state}`)
    lines.push(address.postalCode)
    return lines
  },

  full_inline: address => {
    const lines = []
    const parts = []
    parts.push(address.line1)
    if (address.line2) {
      parts.push(address.line2)
    }
    parts.push(address.city)
    parts.push(address.state)
    parts.push(address.postalCode)
    lines.push(parts.join(', '))
    return lines
  },

  street: address => [address.line1 + (address.line2 ? `, ${address.line2}` : '')],
  city: address => [`${address.city}, ${address.state}`]
}
